import DjHeader from "../components/dj/DjHeader";
import DJPanel from "../components/dj/DJPanel";
import { getDjId } from "../utils/getDjId";
import { DjProvider } from "../context/DjContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useWebSocketNotification from "../hooks/useWebSocketNotification";

function DjPage() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const djId = getDjId();
  const [requestsRefresh, setRequestsRefresh] = useState(0);
  const notifications =
    JSON.parse(localStorage.getItem(`notifications_${djId}`)) || [];

  const refreshDjRequests = () => setRequestsRefresh((prev) => prev + 1);
  useWebSocketNotification(djId, true, refreshDjRequests);

  useEffect(() => {
    if (!djId) {
      navigate("/login");
    }
  }, [djId, navigate]);

  return djId ? (
    <DjProvider djId={djId} token={token}>
      <div className="min-h-screen bg-[#111417] text-textMain font-sans">
        <div className="container mx-auto">
          <DjHeader djId={djId} />
        </div>
        <main className="container mx-auto px-4 py-4">
          <DJPanel
            refreshTrigger={requestsRefresh}
            notifications={notifications}
          />
        </main>
      </div>
    </DjProvider>
  ) : null;
}

export default DjPage;
